/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


$(window).on('load', moveCurrency());
$(window).on('resize', function(){
 	moveCurrency(); 
});


function moveCurrency()
{
 	var w = window.innerWidth;
    if(w < 750) {
      if($('.site-header__link-wrapper .site-header__currency').length) {
        $('.site-header__link-wrapper .site-header__currency').detach().insertAfter('.navigation__container .navigation__links:first-child');
      }
    } else {
      if($('.navigation__container .site-header__currency').length) {
        $('.navigation__container .site-header__currency').detach().prependTo('.site-header__link-wrapper');
      }
    }
}


$('.shopify-currency-form select').on('change', function() {
  $(this)
    .parents('form')
    .submit();
});


$('.product-video-slideshow-open').on('click', function(){
  var vid = $(this).data('media-id');
  if (vid.indexOf('video:') >= 0) {
    var videoId = vid.split('video:')[1];
    if(vid.indexOf('ytvideo:') >= 0) {
      var div = '<div id="videoWrapper"><iframe data-ratio="1.777" src="https://www.youtube.com/embed/' + videoId + '?rel=0&amp;start=16&amp;controls=0&amp;mute=1&amp;showinfo=0&amp;autoplay=1&amp;modestbranding=1&amp;loop=1&amp;playlist=' + videoId + '" frameborder="0" allowfullscreen></iframe></div>';
    } else {
      var div = '<div id="videoWrapper"><iframe src="//player.vimeo.com/video/' + videoId + '?autoplay=1" autoplay="true" frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen=""></iframe></div>';
    }
    
    $('.product-video-slideshow__content').html(div);
    $('#product-video-slideshow').addClass('product-slideshow--show'); 
    $('html').addClass('outline-disabled disable-scroll');
  }
});

// document.addEventListener('DOMContentLoaded', function () {
//   if (window.innerWidth < 992) return;

//   const sliderList = document.querySelector('.product-slideshow__slide-list');

//   if (!sliderList) return;

//   // Block native drag gestures
//   sliderList.addEventListener('mousedown', function (e) {
//     e.stopPropagation();
//     e.preventDefault();
//   }, true); // Use capture phase

//   sliderList.addEventListener('pointerdown', function (e) {
//     e.stopPropagation();
//     e.preventDefault();
//   }, true);
// });

// document.addEventListener('DOMContentLoaded', function () {
//   if (window.innerWidth < 992) return;

//   const sliderList = document.querySelector('.product-slideshow__slide-list');

//   if (!sliderList) return;

//   sliderList.addEventListener('pointerdown', function (e) {
//     const isZoomed = e.target.closest('.product-media--slideshow')?.querySelector('.zoomable-image.zoomed-in');
    
//     // Only block drag if NOT zoomed in
//     if (!isZoomed) {
//       e.stopPropagation();
//       e.preventDefault();
//     }
//   }, true); // use capture to get it early
// });


document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < 992) return;

  const images = document.querySelectorAll('.zoomable-image');

  images.forEach(img => {
    const wrapper = img.closest('.product-media--slideshow');
    if (!wrapper) return;

    let isDragging = false;
    let dragDistance = 0;
    let startX = 0, startY = 0;
    let scrollLeft = 0, scrollTop = 0;

    // Prevent drag-to-slide when zoomed in
    const sliderList = document.querySelector('.product-slideshow__slide-list');
    if (sliderList) {
      sliderList.addEventListener('pointerdown', function (e) {
        const zoomed = wrapper.querySelector('.zoomable-image.zoomed-in');
        if (!zoomed) {
          e.stopPropagation();
          e.preventDefault();
        }
      }, true);
    }

    wrapper.addEventListener('pointerdown', (e) => {
      if (!img.classList.contains('zoomed-in')) return;

      isDragging = true;
      startX = e.clientX;
      startY = e.clientY;
      scrollLeft = wrapper.scrollLeft;
      scrollTop = wrapper.scrollTop;
      wrapper.style.cursor = 'grabbing';
    });

    wrapper.addEventListener('pointermove', (e) => {
      if (!isDragging || !img.classList.contains('zoomed-in')) return;

      e.preventDefault();

      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      dragDistance = Math.sqrt(dx * dx + dy * dy);

      wrapper.scrollLeft = scrollLeft - dx;
      wrapper.scrollTop = scrollTop - dy;
    });

    wrapper.addEventListener('pointerup', (e) => {
      wrapper.style.cursor = 'grab';

      const isZoomed = img.classList.contains('zoomed-in');

      if (!isZoomed && dragDistance < 5) {
        // Zoom in — calculate where user clicked
        const rect = img.getBoundingClientRect();
        const offsetX = e.clientX - rect.left;
        const offsetY = e.clientY - rect.top;
        const originX = (offsetX / rect.width) * 100;
        const originY = (offsetY / rect.height) * 100;

        img.style.transformOrigin = `${originX}% ${originY}%`;
        img.classList.add('zoomed-in');
        wrapper.style.overflow = 'scroll';
        wrapper.style.cursor = 'grab';

      } else if (isZoomed && dragDistance < 5) {
        // Zoom out
        img.classList.remove('zoomed-in');
        img.style.transformOrigin = `center center`;
        wrapper.scrollLeft = 0;
        wrapper.scrollTop = 0;
        wrapper.style.overflow = 'hidden';
        wrapper.style.cursor = 'default';
      }

      isDragging = false;
      dragDistance = 0;
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const toggles = document.querySelectorAll('.accordion-toggle');
  const allowMultipleOpen = false; // Change to true if you want multiple sections open

  // Function to close all accordion sections
  function closeAll() {
    document.querySelectorAll('.accordion-content').forEach(content => {
      content.classList.remove('open');
      content.style.maxHeight = null;
    });

    document.querySelectorAll('.accordion-icon').forEach(icon => {
      icon.classList.remove('open');
    });
  }

  // Setup click events
  toggles.forEach(toggle => {
    toggle.addEventListener('click', function () {
      const content = this.nextElementSibling;
      const icon = this.querySelector('.accordion-icon');
      const isOpen = content.classList.contains('open');

      if (!allowMultipleOpen) {
        closeAll();
      }

      if (!isOpen) {
        content.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';
        icon.classList.add('open');
      } else {
        content.classList.remove('open');
        content.style.maxHeight = null;
        icon.classList.remove('open');
      }
    });
  });

  // Open the first item by default
  const firstToggle = toggles[0];
  if (firstToggle) {
    const firstContent = firstToggle.nextElementSibling;
    const firstIcon = firstToggle.querySelector('.accordion-icon');
    firstContent.classList.add('open');
    firstContent.style.maxHeight = firstContent.scrollHeight + 'px';
    firstIcon.classList.add('open');
  }
});




$('#product-video-slideshow .product-slideshow__close').on('click', function(){
  $('.product-video-slideshow__content').html();
  $('#product-video-slideshow').removeClass('product-slideshow--show'); 
  $('html').removeClass('outline-disabled disable-scroll');
});


$(window).resize(function(){
  let video = '';
  if(video == ''){
    if($('.slideshow__video--loaded')){
      video = $('.slideshow__video--loaded iframe.slideshow__video').html();
    }
  }
  if(window.matchMedia("(max-width: 500px)")){
    if(! $('.slideshow__video--loaded iframe.slideshow__video')){
      $('.slideshow__video--loaded .slideshow__image').after(video);
    }              
  }
});



$(function(){
  
  $('li.dropdown > button').on('click',function(event){
    
    event.preventDefault();
    $(this).toggleClass('selected');
    $(this).parent().find('ul').first().toggle(300);
    
    $(this).parent().siblings().find('ul').hide(200);
    
    //Hide menu when clicked outside
    $(this).parent().find('ul').parent().mouseleave(function(){ 
      var thisUI = $(this);
      $('html').click(function(){
        thisUI.children(".dropdown-menu").hide();
    thisUI.children("a").removeClass('selected');
               
        $('html').unbind('click');
      });
    });
    
    
  });
  
  $(document.body).on('click',".search-wrapper button",function(event){
    let parentWrapper = $(this).parents('.search-wrapper');
    if(! $(parentWrapper).find('input').val().length){
      event.preventDefault();
    }
    if(! $(parentWrapper).hasClass('show-search')){
      event.preventDefault();
      if($('.template-search').length){
        $(parentWrapper).find('input').val('');
      }
    }
    $(this).parent().parent().toggleClass('show-search');
    // if($(parentWrapper).find('input').val().length){
    //   $(parentWrapper).toggleClass('show-search');
    // }
  });

  // Keep collections grid square
  function setGridHeight(){    
    setTimeout(function(){
      let sectionHeight = $('.collection-right').width();
      $('.collections-grid').height(sectionHeight);
    },500);
  }
  setGridHeight();

  $(window).resize(function(){
    setGridHeight();
  });

  // Animate filter arrows
  $(document.body).on('click', ".dropdown button", function(){
    $(this).toggleClass('expanded');
  });

  function updateMobNavPos(){
    if($('.announcement-bar--visible')){
      setTimeout(function(){          
      let bannerHeight = $('.announcement-bar--visible').height();
      let headerHeight = ($('.site-header').height() - bannerHeight);
      // alert(headerHeight);      
      $('.mob-hide .navigation').css('top', headerHeight);
      }, 250);
    }
  }
  updateMobNavPos();
  
  $(document.body).on('click', ".mob-hide", function(){
    updateMobNavPos();
  });
  
  $(window).resize(function(){
    updateMobNavPos();
    if($('body').hasClass('navigation-open') && $('.mob-hide').is(':hidden')){      
      $('body').removeClass('navigation-open');
    }
  })

  $(document.body).on('click',".modal-nav a", function(){
    if(! $(this).hasClass('active')){
      $('.modal-nav a').removeClass('active');
      $(this).addClass('active');
      
      let slideID = $(this).attr('slide-id');
      console.log(slideID);
      $('.size-guide-slide').removeClass('active');
      $('.size-guide-slide[slide-id="'+slideID+'"]').addClass('active');
    }
  });
  $(document.body).on('click',".guide-toggle", function(){
    if(! $('.size-guide.modal').hasClass('show')){
      $('.size-guide.modal').addClass('show');
      $('.modal-wrapper').addClass('show');
    }
  });
  $(document.body).on('click',".modal-wrapper", function(){
    $(this).removeClass('show');
    $('.size-guide.modal').removeClass('show');
  });
  $(document.body).on('click',".size-guide .icon-close", function(){
    $('.modal-wrapper').removeClass('show');
    $('.size-guide.modal').removeClass('show');
  });
  // $(document.body).click(function(e){            
  //    if(!$(e.target).parents().hasClass('size-guide') )
  //    {
  //     console.log('click on it');      
  //    } else {
  //      console.log('not click on it');
  //    }
  // }); 
  // function updateNavPos(){    
  //   if (window.matchMedia("(min-width: 750px)").matches) {
  //     if(! $('.site-header-desknav .navigation').length){
  //       $('nav .navigation').appendTo($('.site-header-desknav nav'));
  //     }
  //   } else {
  //     if($('.site-header-desknav .navigation').length){
  //       $('.site-header-desknav .navigation').appendTo($('nav.mob-hide'));
  //     }
  //   }
  // }
  // updateNavPos();
  // $( window ).resize(function() {
  //   updateNavPos();
  // });
  $(document.body).on('click', ".product__add-to-cart-button", function(){
    $('.ajax-cart__toggle').click();
  });
});

document.addEventListener("fg-gifts:show-slider", (e) => {
  $(document.body).find($('.bogos-slider-info-title')).after('<p class="promotion-subheading">For 3 days only</p>');
  $(document.body).find($('.bogos-badge-title')).text('10% off all hats with any item');
});

$(document).ready(function() {
  

  /* Lock Scrolling */
  function lockScroll() {
    $('body').addClass('lock-scroll');
  }
  function unlockScroll() {
    $('body').removeClass('lock-scroll');
  }

  /* Modal lightbox */

  /* Assign incremental ids to gallery items */
  const gallery = document.querySelectorAll('[data-lightbox="gallery"]');
  i = 0;
  for (const image of gallery) {
    image.setAttribute("data-slide", i);
    i++;
  }

  const sync1 = $("#sync1");
  const sync2 = $("#sync2");
  const slidesPerPage = 3; //globaly define number of elements per page
  //const thumbsPerPage = 12; //globaly define number of elements per page
  const syncedSecondary = true;
  //declare a global variable for slide
  let slide = 0;
  let modalTrigger = false;
  let performSync = true;

  /* Open modal */
  $('*[data-lightbox="gallery"]').on("click",function(e){
    e.preventDefault();
    slide = $(this).data('slide');
    modalTrigger = true;
    $('#lightbox__modal').fadeIn(500);
    $('#lightbox__modal').addClass("modal-open");
    lockScroll();
  });

  /* Close modal button */
  $('#lightbox__modal .btn-close').on("click",function(){
    closeModal();
  });

  /* Close modal function */
  function closeModal() {
    $('#lightbox__modal').fadeOut(500);
    $('#lightbox__modal').removeClass('modal-open');
    unlockScroll();
  }

  /* Keypresses */
  if( $('#lightbox__modal').length ) {
    $(document).on('keyup',function(evt) {
      if( $('#lightbox__modal').hasClass('modal-open') ) {
        let keyCode = evt.keyCode;
        if (keyCode === 27) {
          // Escape pressed, close modal
          closeModal();
        } else if (keyCode === 37) {
          sync1.trigger('prev.owl.carousel');
        } else if (keyCode === 39) {
          sync1.trigger('next.owl.carousel');
        }
        //console.log(keyCode);
      }
    });
  }



  sync1.owlCarousel({
      items: slidesPerPage,
  });

  sync2
  .on('initialized.owl.carousel', function() {
      sync2.find(".owl-item").eq(0).addClass("current");
  })
  .owlCarousel({
    //items: thumbsPerPage,
    items: 1,
  });


  setTimeout(function(){
  
    //kill the carousel
    sync1.trigger('destroy.owl.carousel');
    
    // add the new items 
    let content = '';
    const lightbox = Array.from(document.querySelectorAll('[data-lightbox="gallery"]')).map(e => ({src: e.getAttribute(`src`), mode: e.getAttribute('data-mode'), link: e.getAttribute('data-link')}));
    //console.log(lightbox);
    for (var i = 0; i < lightbox.length; i++) {
      content += '<div class="item ' + lightbox[i].mode + '" data-id="' + i + '"><div class="img-wrapper"><img src="' + lightbox[i].src + '"></div><div class="link">';
      if( lightbox[i].link ) {
        content += '<a href="' + lightbox[i].link + '">View Product</a>';
      }
      content += '</div></div>';
    }
    sync1.html(content);
    
    //reinitialize the carousel (call here your method in which you've set specific carousel properties)
    sync1.owlCarousel({
      items: slidesPerPage,
      slideSpeed: 2000,
      nav: true,
      autoplay: false, 
      dots: false,
      loop: true,
      center: true,
      autoWidth: true,
      margin: 20,
      responsiveRefreshRate: 200,
      navText: ['<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54.312 89.355"><path data-name="Path 3857" d="M47.241 82.298 7.297 47.016 47.241 7.072" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="10"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54.311 89.355"><path data-name="Path 3858" d="m7.071 82.298 39.943-35.282L7.071 7.071" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="10"/></svg>'],
    }).on('changed.owl.carousel', syncPosition);



    //kill the carousel
    sync2.trigger('destroy.owl.carousel');
    
    // add the new items
    let thumbcontent = '';
    const thumbnails = Array.from(document.querySelectorAll('[data-lightbox="thumbnail"]')).map((e)=>{return e.getAttribute(`src`);});
    //console.log(thumbnails);
    for (var i = 0; i < thumbnails.length; i++) {
      thumbcontent += '<div class="item"><img src="' + thumbnails[i] + '"></div>';
    }
    sync2.html(thumbcontent);

    
    sync2.owlCarousel({
      //items: thumbsPerPage,
      dots: false,
      nav: false,
      smartSpeed: 200,
      slideSpeed: 500,
      //slideBy: 1, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
      responsiveRefreshRate: 100,
      responsive: {
        0: {
          items: 4,
        },
        576: {
          items: 6,
        },
        768: {
          items: 8,
        },
        992: {
          items: 10,
        },
        1200: {
          items: 12,
        }
      }
    }).on('changed.owl.carousel', syncPosition2);

  }, 200);

  
  function syncPosition(el) {
    //if you set loop to false, you have to restore this next line
    //var current = el.item.index;

    //if you disable loop you have to comment this block
    let count = el.item.count - 1;
    let current = 0;
    if( modalTrigger == false ) {
      current = Math.round(el.item.index - (el.item.count / 2) - .5);
    } else {
      current = slide;
      sync1.data('owl.carousel').to(current, 100, false);
      setTimeout(function(){
        modalTrigger = false;
      }, 500);
    }

    if (current < 0) {
        current = count;
    }
    if (current > count) {
        current = 0;
    }
    //end block

    sync2
        .find(".owl-item")
        .removeClass("current")
        .eq(current)
        .addClass("current");
    let onscreen = sync2.find('.owl-item.active').length - 1;
    let start = sync2.find('.owl-item.active').first().index();
    let end = sync2.find('.owl-item.active').last().index();
    
    //console.log('count: '+count+' | current: '+current+' | onscreen: '+onscreen+' | start: '+start+' | end: '+end);

    // Update count position
    let countText = (current + 1) + ' of ' + (count + 1);
    $('#gallery-count').text(countText);

    if (current > end) {
      performSync = false;
      sync2.data('owl.carousel').to(current, 100, true);
      setTimeout(function(){
        performSync = true;
      }, 100);
    }
    if (current < start) {
      performSync = false;
      sync2.data('owl.carousel').to(current - onscreen, 100, true);
      setTimeout(function(){
        performSync = true;
      }, 100);
    }
  }

  function syncPosition2(el) {
    if (syncedSecondary) {
      if (performSync == true) {
        if (modalTrigger == false) {
          let number = el.item.index;
          sync1.data('owl.carousel').to(number, 100, true);
        }
      }
    }
  }

  sync2.on("click", ".owl-item", function(e) {
    e.preventDefault();
    let number = $(this).index();
    sync1.data('owl.carousel').to(number, 300, true);
    modalTrigger = false;
  });



  /* Storefront Filters */
  
  /* close on external click */
  $(document).on("click", function(event){
    if (window.matchMedia("(min-width: 750px)").matches) {
      const $trigger = $('details');
      if($trigger !== event.target && !$trigger.has(event.target).length){
          $trigger.removeAttr('open');
      } 
    }              
  });
  
  $('.filters-list .filter-button').on('click', function (event) {
     $('.filters-list .filter-button').not(this).parents('details').removeAttr('open');
  });

  // Filters Panel
  $('#filters-panel-trigger').on('click', function (event) {
    if (window.matchMedia("(max-width: 749px)").matches) {
      openFiltersPanel();
    }
  });
  $('#filters-panel-close').on('click', function (event) {
    if (window.matchMedia("(max-width: 749px)").matches) {
      closeFiltersPanel();
    }
  });
  $('#filters-panel-wrapper').on('click', function (event) {
    if (window.matchMedia("(max-width: 749px)").matches) {
      if (event.target.id === 'filters-panel') {
        closeFiltersPanel();
      }
    }
  });

  function openFiltersPanel() {
    $('#filters-panel').css('transform','translateX(-100%)');
    $('#filters-panel-wrapper').addClass('open');
  }

  function closeFiltersPanel() {
    $('#filters-panel').css('transform','translateX(0)');
    $('#filters-panel-wrapper').removeClass('open');
    $('details').removeAttr('open');
    setTimeout(function(){
      $('#filters-panel').removeAttr('style');
    }, 300);
  }

  // Individual Filter Panel
  $('.filter-panel-close').on('click', function (event) {
    let $filter = $(this).parents('details');
    $('.filter-panel').css('transform','scaleY(1) translateX(0)');
    setTimeout(function(){
      $('.filter-panel').removeAttr('style');
      $filter.removeAttr('open');
    }, 300);
  });


  // Add class and offsets for filter panel wrapper
  $(document).scroll(function () {
    let y = $(this).scrollTop();
    let t = 0;
    let $panel = $('#filters-panel-wrapper');

    if (window.matchMedia("(max-width: 749px)").matches) {
      if ( y > t ) {
        $panel.addClass('fixed');
        $panel.css('top', y);
      } else {
        $panel.css('top', 0);
      }
    }
  });

  // Hide panel and reset on resize
  $(window).resize(function(){
    if (window.matchMedia("(min-width: 750px)").matches) {
      closeFiltersPanel();
    } 
  });


  /* Product Page Mobile Product Image Carousel */
  $(window).on("load resize", function() {
    if( $('.template-product').length ) {
      // only on product page

      let productsCarousel = $('.template-product .product__submedia-list');
      
      if (window.matchMedia("(max-width: 991px)").matches) {

        // initialise the carousel
        productsCarousel.owlCarousel({
          autoplay: false, 
          autoWidth: true,
          center: true,
          dots: true,
          nav: false,
          margin: 20,
          onInitialized: updateDots,
          onChanged: updateDots
        });

        function updateDots(event) {
          $('.product-media .owl-dot').each(function (index) {
            var $mediaItem = $('.product-media .owl-carousel .owl-item').eq(index).find('[data-media-type]');
            
            if ($mediaItem.data('media-type') === 'video' || $mediaItem.data('media-type') === 'external_video') {
              $(this).addClass('dot--video');
            } else {
              $(this).removeClass('dot--video');
            }
          });
        }

        
      } else {

        // destroy the carousel
        if (typeof productsCarousel.data('owl.carousel') != 'undefined') {
          productsCarousel.owlCarousel('destroy');
        }
      }
    }
    
  });

  
  
});

(function () {
  var SELECTOR = "#campaign-masonry-grid .js-campaign-carousel";
  var MOBILE_MAX = 749;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function init($el) {
    if ($el.hasClass("owl-loaded")) return;

    $el.owlCarousel({
      items: 1,
      margin: 12,
      stagePadding: 16,
      loop: false,
      dots: true,
      nav: false,
      mouseDrag: true,
      touchDrag: true
    });
  }

  function destroy($el) {
    if (!$el.hasClass("owl-loaded")) return;

    $el.trigger("destroy.owl.carousel");

    // unwrap owl structure back to original children
    $el.find(".owl-stage-outer").children().unwrap();
    $el.find(".owl-stage").children().unwrap();

    // cleanup leftovers
    $el.removeClass("owl-loaded owl-hidden");
    $el.find(".owl-stage, .owl-nav, .owl-dots").remove();

    // remove inline styles owl added
    $el.removeAttr("style");
    $el.children().removeAttr("style");
  }

  function run() {
    if (!window.jQuery || !jQuery.fn || !jQuery.fn.owlCarousel) return;

    var $el = jQuery(SELECTOR);
    if (!$el.length) return;

    if (isMobile()) init($el);
    else destroy($el);
  }

  // ✅ Run immediately (fixes “only on resize” issue)
  run();

  // Fallback in case this script is loaded very early
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  }

  // Resize (debounced)
  var t;
  window.addEventListener("resize", function () {
    clearTimeout(t);
    t = setTimeout(run, 150);
  });

  // ✅ Shopify Theme Editor (sections can be re-rendered without full page load)
  document.addEventListener("shopify:section:load", run);
  document.addEventListener("shopify:section:reorder", run);
  document.addEventListener("shopify:block:select", run);
})();


document.addEventListener("DOMContentLoaded", function () {
    let body = document.querySelector("body");

    function findCookieBanner() {
        let cookieBanner = document.querySelector("#shopify-pc__banner");

        if (cookieBanner) {
            console.log("✅ Cookie banner found:", cookieBanner);
            applyOverlay(cookieBanner); // Call function to lock scroll and add overlay
        } else {
            console.warn("⏳ Cookie banner not found yet. Retrying...");
            setTimeout(findCookieBanner, 500); // Retry every 500ms
        }
    }

    function applyOverlay(cookieBanner) {
        console.log("Applying overlay...");

        // Create an overlay element
        let overlay = document.createElement("div");
        overlay.id = "cookie-overlay";
        overlay.style.position = "fixed";
        overlay.style.top = "0";
        overlay.style.left = "0";
        overlay.style.width = "100%";
        overlay.style.height = "100%";
        overlay.style.background = "rgba(0, 0, 0, 0.3)"; // Semi-transparent overlay
        overlay.style.zIndex = "9998"; // Below the cookie banner but above everything else
        document.body.appendChild(overlay);

        // Function to lock scrolling
        function lockScroll() {
            body.style.overflow = "hidden";
        }

        // Function to unlock scrolling
        function unlockScroll() {
            body.style.overflow = "";
            overlay.style.display = "none";
        }

        lockScroll(); // Apply scrolling lock

        // MutationObserver to detect when the banner disappears
        let observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.target.style.display === "none" || !cookieBanner.isConnected) {
                    console.log("✅ Cookie banner dismissed! Removing overlay.");
                    observer.disconnect();
                    unlockScroll();
                }
            });
        });

        observer.observe(cookieBanner, { attributes: true, attributeFilter: ["style"] });

        // Detect click on accept/dismiss buttons inside the banner
        let acceptBtn = cookieBanner.querySelector("button");
        if (acceptBtn) {
            console.log("✅ Accept button found, adding click listener...");
            acceptBtn.addEventListener("click", function () {
                console.log("✅ Cookie banner accepted, removing overlay...");
                observer.disconnect();
                unlockScroll();
            });
        } else {
            console.warn("⚠️ No accept button found inside the cookie banner!");
        }
    }

    // Start searching for the cookie banner dynamically
    findCookieBanner();

  $('.recommended-carousel').owlCarousel({
      loop: true,
      margin: 20,
      nav: true,
      lazyLoad: true,
      dots: true,
      responsive: {
        0: { items: 1 },
        575: { items: 2 },
        1000: { items: 2 }
      }
    });
    document.addEventListener('fg-gifts:added', () => {
      let url = window.location.href;
      if(! (url.indexOf('cart_open') > -1)){   
        if (url.indexOf('?') > -1){
          url += '&cart_open'
        } else {
          url += '?cart_open'
        }
      }
      window.location.href = url;       
    });

    if(window.location.href.indexOf("cart_open") > -1) {
      setTimeout(function(){
        $('.ajax-cart__toggle').click();
      },300);      
    }
});
